export default __webpack_public_path__ + "static/pre-flight-page-preview-section-bg-mob-c8a24f40a9dabdd9df5d00d6ddcb84a5.jpg";